import { Col } from '../grid';
export default Col;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/col/index.js
// module id = 289
// module chunks = 1